<template>
  <div class="product-detail-table">
    <table>
      <thead>
        <tr>
          <th
            v-for="(column, index) in tableHead"
            :key="column[index]"
          >
            {{ column }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(row, index) in tableBody"
          :key="row[index]"
        >
          <td
            v-for="(column, index) in row"
            :key="column[index]"
          >
            {{ column }}
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  props: {
    feedingSuggestionTable: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    tableHead() {
      if (!this.feedingSuggestionTable) {
        return;
      }
      const feedingSuggestionHead = {};

      for (const key in this.feedingSuggestionTable[0]) {
        feedingSuggestionHead[key] = this.feedingSuggestionTable[0][key];
      }

      return feedingSuggestionHead;
    },

    tableBody() {
      if (!this.feedingSuggestionTable) {
        return [];
      }

      let feedingTable = [];

      try {
        feedingTable = JSON.parse(JSON.stringify(this.feedingSuggestionTable));
        feedingTable.shift();
      } catch (error) {
        this.$log.error('Error occurred while JSON.parse()', error);
      }

      return feedingTable;
    },
  },
};
</script>

<style lang="scss" scoped>
.product-detail-table {
  margin-bottom: math.div($ui-height, 2);

  table {
    width: 100%;

    @include bp(m) {
      width: 85%;
    }

    th {
      padding: $pad;
      border: 1px solid $color-white;
      background-color: palette(sand, base);
      text-align: center;
    }

    td {
      padding: $pad;
      border: 1px solid $color-white;
      background-color: palette(sand, light);
      text-align: center;
    }
  }
}
</style>
